import { useState, useContext } from 'react';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { H2 } from 'foundations-components/transitional/components/H2';
import { Small } from 'foundations-components/transitional/components/Small';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import TrackingContext from 'ui-forms-components/contextProviders/TrackingContext';
import { FIELD_OPTIONS } from 'ui-forms-components/constants/TrackingEvents';
import { View } from 'foundations-components/transitional/components/View';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AvailableOptionsModal = ({
  link = '',
  options = [],
  closeModal = () => {},
  addSelectedOptions = () => {}
}) => {
  const [selectedOptions, setSelectedOptions] = useState([]);
  const {
    track
  } = useContext(TrackingContext);
  const updateCheckbox = option => ({
    target: {
      checked
    }
  }) => {
    if (checked) {
      setSelectedOptions([...new Set([...selectedOptions, option.value])]);
    } else {
      setSelectedOptions(selectedOptions.filter(value => value !== option.value));
    }
  };
  return /*#__PURE__*/_jsxs(Modal, {
    size: "auto",
    "data-test-id": "add-more-options-modal",
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        "data-test-id": "close",
        onClick: e => closeModal(e)
      }), /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'availableOptions.title'
        })
      })]
    }), /*#__PURE__*/_jsx(DialogBody, {
      children: /*#__PURE__*/_jsxs(TFlex, {
        direction: "column",
        justify: "between",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: 'availableOptions.body'
        }), /*#__PURE__*/_jsx(View, {
          marginBlockStart: "200",
          as: "div",
          children: options.map((option, idx) => /*#__PURE__*/_jsx(Checkbox, {
            "data-test-id": `available-options-${idx}`,
            onChange: updateCheckbox(option),
            children: option.value
          }, option.value))
        }), /*#__PURE__*/_jsx(Button, {
          size: "small",
          use: "primary",
          "data-test-id": "add-options-confirm",
          disabled: !selectedOptions.length,
          onClick: () => {
            addSelectedOptions(selectedOptions);
            track(FIELD_OPTIONS.ADDED_AVAILABLE_OPTIONS);
          },
          marginBlockStart: "300",
          marginBlockEnd: "100",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'availableOptions.add'
          })
        })]
      })
    }), /*#__PURE__*/_jsx(DialogFooter, {
      children: /*#__PURE__*/_jsx(Small, {
        use: "help",
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: 'availableOptions.doYouWantANewOption_jsx',
          options: {
            href: link,
            external: true
          },
          elements: {
            UILink: Link
          }
        })
      })
    })]
  });
};
export default AvailableOptionsModal;